export class InflowOutflowDto {
  static fromApi(res, fileType) {
    return {
      data: res.data,
      filename: retrieveFileNameFromHeaders(res.headers, fileType),
      contentType: res.headers["content-type"],
    };
  }
}

const retrieveFileNameFromHeaders = (headers, fileType) => {
  const contentDisposition = headers["content-disposition"];
  let filename = `inflow_outflow_report.${fileType}`;

  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match?.[1]) {
      filename = match[1];
    }
  }
  return filename;
};
